// import UXArmyLogo from "../../uxarmy-logo.svg";
import { useEffect } from "react";
import { ErrorBoundary } from "react-error-boundary";
// import { goBackToWebsite } from "../../utills/common";
// import { Button, Result, Image, Typography, Layout } from "antd";
import ErrorPage from "./ErrorPage";

// const { Header, Content } = Layout;
// const { Paragraph, Text } = Typography;

const CHUNK_RELOAD_KEY = "uxa:last-chunk-reload-signature";

function isChunkLoadError(error) {
  const message = String(error?.message || "");
  const name = String(error?.name || "");

  return (
    name === "ChunkLoadError" ||
    /loading chunk \d+ failed/i.test(message) ||
    /failed to fetch dynamically imported module/i.test(message) ||
    /importing a module script failed/i.test(message) ||
    /error loading dynamically imported module/i.test(message) ||
    /expected a javascript module script but the server responded with a mime type of text\/html/i.test(message)
  );
}

function Fallback({ error, resetErrorBoundary }) {
  useEffect(() => {
    if (!isChunkLoadError(error)) return;

    const reloadSignature = [window.location.pathname, error?.name, error?.message].filter(Boolean).join("|");
    if (sessionStorage.getItem(CHUNK_RELOAD_KEY) === reloadSignature) return;

    sessionStorage.setItem(CHUNK_RELOAD_KEY, reloadSignature);
    window.location.reload();
  }, [error]);

  return <ErrorPage error={error} resetErrorBoundary={resetErrorBoundary} />;
}

export default function UXErrorBoundary({ children }) {
  function fallbackRender({ error, resetErrorBoundary }) {
    return <Fallback error={error} resetErrorBoundary={resetErrorBoundary} />;
  }

  // const FallbackComponent = ({ error }) => {
  //   return (
  //     <Layout>
  //       <Header className='bg-white'>
  //         <Image src={UXArmyLogo} preview={false} />
  //       </Header>

  //       <Content className='bg-white'>
  //         <Result
  //           status='warning'
  //           title='An error occurred'
  //           subTitle={
  //             <Text strong style={{ fontSize: 16 }}>
  //               {error?.message}
  //             </Text>
  //           }
  //           extra={[
  //             <Button type='primary' key='dashboard' onClick={() => goBackToWebsite()}>
  //               Back to Dashboard
  //             </Button>,
  //             <Button key='retry' onClick={() => window.location.reload()}>
  //               Retry
  //             </Button>,
  //           ]}
  //         >
  //           <Paragraph strong style={{ fontSize: 16 }}>
  //             Stack Trace:
  //           </Paragraph>

  //           <pre>{error?.stack}</pre>
  //         </Result>
  //       </Content>
  //     </Layout>
  //   );
  // };

  return (
    <ErrorBoundary
      fallbackRender={fallbackRender}
      onReset={() => {
        sessionStorage.removeItem(CHUNK_RELOAD_KEY);
      }}
    >
      {children}
    </ErrorBoundary>
  );
}
